import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './NewsArticle.css';

const API_URL = process.env.REACT_APP_API_URL;

export default function NewsArticle() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    window.scrollTo(0, 0);
    fetch(`${API_URL}/api/news/${id}`)
      .then(res => res.json())
      .then(data => {
        setArticle(data);
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    if (article) {
      document.title = article.title;
    }
  }, [article]);

  if (loading) return <div className="news-article-page-wrapper"><p>Loading...</p></div>;
  if (!article) return <div className="news-article-page-wrapper"><p>Article not found.</p></div>;

  // Debug DELETE
  const imgSrc = article.image && article.image.startsWith('/uploads') ? `${API_URL}${article.image}` : article.image;
  console.log('Article:', article.title, 'Image field:', article.image, 'Computed src:', imgSrc);

  const formattedBody = article.body ? article.body.replace(/\n/g, '<br />') : '';

  return (
    <section className="news-article-page-wrapper" aria-labelledby="article-title">
      <button onClick={() => navigate('/news')} className="news-article-back-button" aria-label="Back to News">
        Back to News
      </button>
      <h2 id="article-title" className="news-article-title">{article.title}</h2>
      <span className="news-article-date">{article.date}</span>
      {article.image && <img src={imgSrc} alt={article.title} className="news-article-image-full" />}
      <div className="news-article-body" dangerouslySetInnerHTML={{ __html: formattedBody }} />
    </section>
  );
} 